import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { ConnectionService } from '../services/connection.service';

export const opponentsResolver = () => {
  return inject(ConnectionService)
    .getOpponents()
    .pipe(
      map(list => list.data),
      catchError(error => {
        console.log(error);
        return of(false);
      })
    );
};
